import React, { useEffect, useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRemitterData } from "../../../Store/Slices/AuthSlice";
import { CheckCircle, AlertCircle, CreditCard, Loader2, Shield, XCircle } from "lucide-react";

const Ppisettlement1 = () => {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [impsType, setImpsType] = useState("IMPS1");
  const [publicIp, setPublicIp] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(null);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [navigateBeni, setNavigateBeni] = useState(false);
  const [navigateRegister, setNavigateRegister] = useState(false);
  const [instRef, setInstRef] = useState("");
  const [availableLimit, setAvailableLimit] = useState(0);
  const [consumeLimit, setConsumeLimit] = useState(0);
  const [limitTotal, setLimitTotal] = useState(0);
  const [blockVerify, setBlockVerify] = useState(false);


  const { callApi: verifyCustomer } = useApi("/dmt/verifyCustomer", "POST");
  const details = useSelector((store) => store?.auth?.employeeDetails);
  const { lat, lng, status } = useSelector((s) => s.location);
  const latlong = `${lat}_${lng}`;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetch("https://api64.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setPublicIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));
  }, []);

  const handleSubmit = async () => {
    setMessage("");
    setMessageType("");
    setIsLoading(true);

    // if (!name || !mobile || !impsType) {
    //   setMessage("Please fill all fields before proceeding.");
    //   setMessageType("error");
    //   setIsLoading(false);
    //   return;
    // }
    if (!mobile) {
      setMessage("Please enter mobile number.");
      setMessageType("error");
      setIsLoading(false);
      return;
    }

    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setMessage('Mobile number must start with a digit between 6 and 9 and 10-digit.');
      setMessageType("error");
      setIsLoading(false);
      return;
    }

    const isSequential = (str) => {
      str = str.toLowerCase().replace(/ /g, "");
      for (let i = 0; i < str.length - 2; i++) {
        const a = str.charCodeAt(i);
        const b = str.charCodeAt(i + 1);
        const c = str.charCodeAt(i + 2);
        if (b === a + 1 && c === b + 1) return true;
      }
      return false;
    };

    if (isSequential(name)) {
      setMessage("Name should not contain sequential characters like 'abc'.");
      setMessageType("error");
      setIsLoading(false);
      return;
    }


    if (latlong === "") {
      setMessage("Please enable location");
      setMessageType("error");
      setIsLoading(false);
      return;
    }

    if (publicIp === "") {
      setMessage("Unable to fetch public IP. Please try again later.");
      setMessageType("error");
      setIsLoading(false);
      return;
    }

    try {
      const requestBody = {
        mobile_number: mobile,
        name: name,
        imps_type: impsType,
        merchant_id: details?.userId,
        username: details?.username,
        latlong: latlong,
        public_ip: publicIp,
      };


      const response = await verifyCustomer(requestBody);

      if (response?.type === "IMPS2") {
        dispatch(setRemitterData(response));
        setName(response?.remitter_name || name);
        setIsVerified(response?.is_verified);
        setIsFormDisabled(true);
        setLimitTotal(response?.remitter_data?.limitTotal);
        setAvailableLimit(response?.remitter_data?.limitAvailable);
        setConsumeLimit(response?.remitter_data?.limitConsumed);
        setImpsType("IMPS2");
        setInstRef(response?.reference_key)
        if (response?.is_verified === true && response?.remitter_data?.kyctypeFlag === true) {
          setNavigateBeni(true);
        } else {
          setNavigateRegister(true);
        }
      }
      else if (response?.type === "IMPS") {
        // ✅ IMPS1 normalization

        dispatch(setRemitterData({
          ...response,
          type: "IMPS1"
        }));

        // setName(response?.remitter_name);
        setName(response?.remitter_name || name);
        setInstRef(response?.reference_key);
        setIsVerified(response?.is_verified);
        setIsFormDisabled(true);

        setImpsType("IMPS1");

        if (response?.customer_verification_message) {
          setMessage(response.customer_verification_message);
          setMessageType("success");
        }

        // if (response?.is_verified === true) {
        //   setNavigateBeni(true);
        // }
        if (response?.is_verified === true) {
          if (response?.customer_verification_message === "Customer already registered") {
            const dataToSend = {
              name: response?.remitter_name || name,
              mobile,
              publicIp,
              latlong,
              instRef: response?.reference_key,
              impsType: "IMPS1",
              availableLimit,
              consumeLimit,
              limitTotal,
            };
            navigate("/ppiremitter", { state: dataToSend });
          } else {
            setNavigateBeni(true);
          }
        }
        else {
          setNavigateRegister(true);
        }
      }
      else if (response?.error || response?.status === 202) {
        setMessage(response?.message || "Verification failed");
        setMessageType("error");

        // 🔒 block verify button
        setBlockVerify(true);
      } else {
        setMessage(response.message);
        setMessageType("error");
      }
    }
    catch (error) {
      setMessage(
        error?.response?.data?.message ||
        "Something went wrong. Please try again."
      );
      setMessageType("error");
      setBlockVerify(true); // 🔒 block button on hard failure
    }
    finally {
      setIsLoading(false);
    }
  };

  const handlenavigateBeni = () => {

    const dataToSend = {
      name,
      mobile,
      publicIp,
      latlong,
      instRef,
      impsType,
      availableLimit,
      consumeLimit,
      limitTotal,
    };
    navigate("/aepsremitter", { state: dataToSend });
  }

  // const handlenavigateRegister = () => {
  //   const dataToSend = {
  //     name,
  //     mobile,
  //     publicIp,
  //     latlong,
  //     instRef,
  //     impsType,
  //   };

  //   // if (impsType === "IMPS1") {
  //   //   navigate("/registercustomer", { state: dataToSend });
  //   // } else if (impsType === "IMPS2") {
  //   //   navigate("/registercustomers", { state: dataToSend });
  //   // }
  //   // navigate("/registercustomers", { state: dataToSend });
  //   navigate("/registercustomers", {
  //     state: {
  //       name,
  //       mobile,
  //       publicIp,
  //       latlong,
  //       instRef,
  //       impsType,
  //       merchantId: merchantid,
  //       referenceKey: response?.reference_key   // 🔥 ADD THIS
  //     }
  //   });
  // };

  const handlenavigateRegister = () => {
    navigate("/registercustomers", {
      state: {
        name,
        mobile,
        publicIp,
        latlong,
        instRef,              // ← reference_key from verifyCustomer
        impsType,
        merchantId: details?.userId
      }
    });
  };

  const resetForm = () => {
    setName("");
    setMobile("");
    setImpsType("");
    setMessage("");
    setMessageType("");
    setIsVerified(null);
    setIsFormDisabled(false);
    setNavigateRegister(false);
    setNavigateBeni(false);
    setBlockVerify(false);
  };

  //   const impsOptions = [
  //     { label: "Bank1", value: "IMPS1" },
  //     { label: "Bank2", value: "IMPS2" },
  //   ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10 px-4">
      <div className="max-w-2xl mx-auto space-y-8">

        <div className="text-center">
          <div className="mx-auto w-14 h-14 rounded-2xl
                        bg-gradient-to-br from-indigo-600 to-cyan-500
                        flex items-center justify-center text-white shadow-lg">
            <CreditCard className="w-7 h-7" />
          </div>
          <h1 className="mt-4 text-3xl font-semibold text-slate-900">
            PPI
          </h1>
          <p className="mt-1 text-slate-600">
            Verify customer and proceed with secure transfers
          </p>
        </div>

        <div
          className="bg-white/90 backdrop-blur-xl rounded-3xl
                   border border-slate-200
                   shadow-[0_30px_80px_-25px_rgba(0,0,0,0.35)]
                   p-8"
        >

          {isVerified !== null && (
            <div
              className={`flex items-center gap-3 px-4 py-3 rounded-xl mb-6
              ${isVerified
                  ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                  : "bg-rose-50 text-rose-700 border border-rose-200"
                }`}
            >
              {isVerified ? <Shield size={18} /> : <XCircle size={18} />}
              <span className="font-semibold text-sm">
                {isVerified ? "Customer Verified" : "Customer Not Verified"}
              </span>
            </div>
          )}

          <div className="space-y-5">
            <p className="text-xs uppercase tracking-widest text-slate-500">
              Step 1 · Customer Details
            </p>

            {/* <div>
              <label className="text-sm font-medium text-slate-700">
                Full Name
              </label>
              <div className="relative mt-1">
                <User className="absolute left-3 top-1/2 -translate-y-1/2
                               text-slate-400 w-4 h-4" />
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={isFormDisabled}
                  placeholder="Enter full name"
                  className={`w-full pl-10 pr-4 py-3 rounded-xl
                            border border-slate-300
                            focus:border-indigo-600 focus:outline-none
                            ${isFormDisabled ? "bg-slate-100" : ""}`}
                />
              </div>
            </div> */}

            <div>
              <label className="text-sm font-medium text-slate-700">
                Mobile Number
              </label>
              <input
                value={mobile}
                maxLength={10}
                onChange={(e) =>
                  /^\d{0,10}$/.test(e.target.value) && setMobile(e.target.value)
                }
                disabled={isFormDisabled}
                placeholder="10-digit mobile number"
                className={`mt-1 w-full px-4 py-3 rounded-xl
                          border border-slate-300
                          focus:border-indigo-600 focus:outline-none
                          ${isFormDisabled ? "bg-slate-100" : ""}`}
              />
            </div>
          </div>

          {message && (
            <div
              className={`mt-6 flex items-center gap-2 px-4 py-3 rounded-xl text-sm
              ${messageType === "success"
                  ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                  : "bg-rose-50 text-rose-700 border border-rose-200"
                }`}
            >
              {messageType === "success"
                ? <CheckCircle size={16} />
                : <AlertCircle size={16} />}
              {message}
            </div>
          )}

          <div className="mt-8 space-y-3">
            <button
              onClick={handleSubmit}
              // disabled={isLoading || !name || !mobile || !impsType || isFormDisabled || blockVerify}
              disabled={isLoading || !mobile || !impsType || isFormDisabled || blockVerify}
              className={`w-full py-3 rounded-xl font-semibold text-white
              flex items-center justify-center gap-2
              ${isLoading || !mobile || !impsType || isFormDisabled
                  ? "bg-slate-400"
                  : "bg-gradient-to-r from-indigo-600 to-cyan-500 hover:shadow-lg"
                }`}
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Verifying…
                </>
              ) : (
                "Verify Customer"
              )}
            </button>

            {isFormDisabled && (
              <button
                onClick={resetForm}
                className="w-full py-3 rounded-xl
                         border border-slate-300
                         text-slate-700 font-semibold
                         hover:bg-slate-50"
              >
                Start New Verification
              </button>
            )}

            {navigateBeni && (
              <button
                onClick={handlenavigateBeni}
                className="w-full py-3 rounded-xl
                         border border-indigo-600
                         text-indigo-700 font-semibold
                         hover:bg-indigo-50"
              >
                Proceed to Remittance
              </button>
            )}

            {navigateRegister && (
              <button
                onClick={handlenavigateRegister}
                className="w-full py-3 rounded-xl
                         border border-indigo-600
                         text-indigo-700 font-semibold
                         hover:bg-indigo-50"
              >
                Register Customer
              </button>
            )}
          </div>
        </div>

        <p className="text-center text-xs text-slate-500">
          Secure • Encrypted • RBI-compliant transactions
        </p>
      </div>
    </div>
  );


};

export default Ppisettlement1;